import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    alias: '首页',
    component: Home,
    meta: {
      isLogin: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@//views/sign/register.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/sign/login.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/smsLogin',
    name: 'smsLogin',
    component: () => import('@/views/sign/smsLogin.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/guestmessage',
    name: 'guestmessage',
    component: () => import('@/views/home/guestmessage/index.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/guestDetail',
    name: 'guestDetail',
    component: () => import('@/views/home/guestmessage/guestDetail.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/conference',
    name: 'conference',
    alias: '大会',
    component: () => import('@/views/conference/index.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/exhibition',
    name: 'exhibition',
    alias: '云展',
    component: () => import('@/views/exhibition/area.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/product',
    name: 'product',
    alias: '产品',
    component: () => import('@/views/exhibition/product.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/prodetail',
    name: 'prodetail',
    alias: '产品详情',
    component: () => import('@/views/exhibition/components/prodetail.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/exhibitor',
    name: 'exhibitor',
    alias: '展商',
    component: () => import('@/views/exhibition/exhibitor.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/exhibitorDetail',
    name: 'exhibitorDetail',
    alias: '展商详情',
    component: () => import('@/views/exhibition/components/exhibitorDetail.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/active',
    name: 'active',
    alias: '活动',
    component: () => import('@/views/active/index.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/activelist',
    name: 'activelist',
    component: () => import('@/views/active/activelist/index.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/activedetail',
    name: 'activedetail',
    component: () => import('@/views/active/activelist/activedetail.vue'),
  },
  {
    path: '/international',
    name: 'international',
    alias: '国际贸易',
    component: () => import('@/views/business/international.vue')
  },
  {
    path: '/business',
    name: 'business',
    alias: '国内贸易',
    component: () => import('@/views/business/domestic.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/pair',
    name: 'pair',
    component: () => import('@/views/pair/pair.vue'),
    meta: {
      isLogin: true,
      isImprove:true
    }
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('@/views/pair/success.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/news',
    name: 'news',
    alias: '新闻',
    component: () => import('@/views/news/index.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/newsdetails',
    name: 'newsdetails',
    component: () => import('@/views/news/components/newsDetails.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/mine',
    name: 'mine',
    alias: '我的',
    component: () => import('@/views/mine/data.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/myproduct',
    name: 'myproduct',
    component: () => import('@/views/mine/components/collectProduct.vue'),
  },
  {
    path: '/mycompany',
    name: 'mycompany',
    component: () => import('@/views/mine/components/collectCompany.vue')
  },
  {
    path: '/myactive',
    name: 'myactive',
    component: () => import('@/views/mine/components/collectActive.vue')
  },
  {
    path: '/dataEdit',
    name: 'dataEdit',
    component: () => import('@/views/mine/components/dataEdit.vue')
  },
  {
    path: '/demandissue',
    name: 'demandissue',
    component: () => import('@/views/mine/components/demandIssue.vue')
  },
  {
    path: '/myresponse',
    name: 'myresponse',
    component: () => import('@/views/mine/components/myResponse.vue')
  },
  {
    path: '/mymessage',
    name: 'mymessage',
    component: () => import('@/views/mine/components/myMessage.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    alias: '意见反馈',
    component: () => import('@/views/mine/feedback.vue')
  },
  {
    path: '/inbox',
    name: 'inbox',
    alias: '企业收件箱',
    component: () => import('@/views/mine/inbox.vue')
  },
  {
    path: '/verifyEmail',
    name: 'verifyEmail',
    component: () => import('@/views/sign/verifyEmail.vue')
  }
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
